import ApiClient from "@common/api/ApiClient";

class AgeVerificationConfigClient extends ApiClient {
  constructor() {
    super("AgeVerificationConfiguration");
    this.setApiUrlKey("comp_api_url");
  }

  MetaData = async () => {
    return await this.get("Create");
  };

  Create = async (payload) => {
    return await this.post(`Create`, payload);
  };

  Read = async () => {
    const record = await this.get(`Read`);
    return { record };
  };

  ReadForUpdate = async () => {
    return await this.get(`Update`);
  };

  Update = async (payload) => await this.post(`Update`, payload);
}

const client = new AgeVerificationConfigClient();

export default client;
